import React, { useState, useEffect } from 'react';
import './CompanyInfoModal.css';

type CompanyEditModalProps = {
	companyId: string;
	InitialhubspotId: string;
	onClose: () => void;
};

const CompanyEditModal: React.FC<CompanyEditModalProps> = ({
	companyId,
	InitialhubspotId,
	onClose
}) => {
	const [hubspotId, sethubspotId] = useState<string>(InitialhubspotId || '');
	const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(hubspotId);
			setStatus('success');
		} catch (err) {
			setStatus('error');
		}
	};

	useEffect(() => {
		sethubspotId(InitialhubspotId);
	}, [InitialhubspotId]);

	return (
		<div className="company-edit-modal">
			<div className="company-edit-modal-content">
				<span className="company-edit-close-btn" onClick={onClose}>
					&times;
				</span>
				<h2 className="large-company-header-title">
					Company Hubspot ID:
				</h2>

				<div>
					<label className="company-edit-label">Hubspot ID:</label>
					<input
						className="company-edit-input"
						type="text"
						value={hubspotId}
						disabled
					/>
				</div>

				<button className="company-info-copy-btn" onClick={handleCopy}>
					Copy to Clipboard
				</button>

				<div className="status-message">
					{status === 'success' && (
						<span className="success">Copied successfully!</span>
					)}
					{status === 'error' && (
						<span className="error">
							Failed to copy. Try again.
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default CompanyEditModal;
